/* istanbul ignore file -- @preserve */

import { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
  // `primary` on ContactDepot is scoped to the contact the depot is attached to
  // (a contact is the primary for a depot — the depot is not "primary" on its
  // own). Normalizing by `id` would make every contact share one ContactDepot
  // entity, so the last-written `primary` would leak across contacts and the
  // Edit Contact modal would pre-check the wrong depots. Keep ContactDepot
  // embedded in its parent contact instead.
  ContactDepot: {
    keyFields: false,
  },
  Appointment: {
    fields: {
      history: {
        keyArgs: ['filters'],
        merge(existing = {}, incoming) {
          const { collection: existingColection = [] } = existing;
          const { collection: incomingCollection = [] } = incoming;

          // use incoming as default and overwrite the collection value
          return {
            ...incoming,
            collection: [...existingColection, ...incomingCollection],
          };
        },
      },
      notes: {
        keyArgs: false,
        // This functionality only applies to collections with infinite scroll.
        merge(existing = {}, incoming) {
          const { collection: existingColection = [] } = existing;
          const { collection: incomingCollection = [] } = incoming;

          // use incoming as default and overwrite the collection value
          return {
            ...incoming,
            collection: [...existingColection, ...incomingCollection],
          };
        },
      },
    },
  },
  Customer: {
    fields: {
      history: {
        keyArgs: false,
        // This functionality only applies to collections with infinite scroll.
        merge(existing = {}, incoming) {
          const { collection: existingColection = [] } = existing;
          const { collection: incomingCollection = [] } = incoming;

          // use incoming as default and overwrite the collection value
          return {
            ...incoming,
            collection: [...existingColection, ...incomingCollection],
          };
        },
      },
    },
  },
  Query: {
    fields: {
      notifications: {
        keyArgs: ['filters'],
        merge(
          existing: NotificationsQuery['notifications'],
          incoming: NotificationsQuery['notifications'],
        ): NotificationsQuery['notifications'] {
          const { collection: existingColection = [] } = existing ?? {};
          const { collection: incomingCollection = [] } = incoming;

          return {
            ...incoming,
            collection: existingColection.concat(incomingCollection),
          };
        },
      },
    },
  },
  SentinelTeam: {
    fields: {
      teamMembers: {
        merge(_existing, incoming) {
          return incoming;
        },
      },
    },
  },
};
